<template>
  <div>
    <h6 v-if="label || $slots.default" class="mb-50">
      <slot>
        {{ label }}
      </slot>
    </h6>
    <b-input-group
      class="input-group-merge"
      :append="append"
      :prepend="prepend"
    >
      <b-form-input
        v-model="localVModel"
        :type="type"
        :disabled="disabled"
        :placeholder="placeholder"
        :formatter="formatIbanNumber"
        :state="state"
        @blur="$emit('blur', $event)"
        @change="$emit('change', $event)"
        @input="$emit('input', $event)"
        @update="$emit('update', $event)"
        aria-describedby="input-live-feedback"
        :aria-invalid="state"
      />
    </b-input-group>
    <b-form-invalid-feedback id="input-live-feedback" :state="state">
      {{ stateText }}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
import { BInputGroup, BFormInput, BFormInvalidFeedback } from "bootstrap-vue";
import { formatIbanNumber } from "@/utils/methods";

export default {
  components: {
    BInputGroup,
    BFormInput,
    BFormInvalidFeedback,
  },
  props: {
    value: {
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "text",
    },
    append: {
      type: String,
      default: null,
    },
    prepend: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    state: {
      type: Boolean,
      default: null,
    },
    stateText: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      localVModel: null,
      formatIbanNumber,
    };
  },
  created() {
    this.localVModel = this.value;
  },
  watch: {
    value(value) {
      this.localVModel = value;
    },
    localVModel(value) {
      this.$emit("input", value);
    },
  },
};
</script>
